import { createContext, useContext, useState, useEffect } from 'react';

const RecipeFiltersContext = createContext();

const defaultFilters = {
  sortBy: 'random',
  selectedCategories: [],
  ratingRange: [1, 5],
};

export const RecipeFiltersProvider = ({ children }) => {
  const savedFilters = JSON.parse(localStorage.getItem('recipeFilters'));
  const [filters, setFilters] = useState(savedFilters || defaultFilters);

  const updateFilters = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  const clearFilters = () => {
    setFilters(defaultFilters);
    localStorage.removeItem('recipeFilters');
  };

  useEffect(() => {
    localStorage.setItem('recipeFilters', JSON.stringify(filters));
  }, [filters]);

  return (
    <RecipeFiltersContext.Provider value={{ filters, updateFilters, clearFilters }}>
      {children}
    </RecipeFiltersContext.Provider>
  );
};

export const useFilters = () => useContext(RecipeFiltersContext);
